var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Gallery'),_c('v-switch',{attrs:{"label":"Show image colors"},model:{value:(_vm.isColored),callback:function ($$v) {_vm.isColored=$$v},expression:"isColored"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }